class PredictiveSearch extends HTMLElement {
    constructor() {
      super();
  
      this.input = this.querySelector('input[type="search"]');
      this.predictiveSearchResults = document.querySelector('#predictive-search');
      this.initialSearchResults = document.querySelector('#initial-search');
  
      this.input.addEventListener('input', this.debounce((event) => {
        this.onChange(event);
      }, 300).bind(this));

      this.input.addEventListener('click', () => {
        this.onInitialClick();
      })

      this.input.addEventListener('input', (e) => {
          if (e.target.value) {
            document.querySelector('#predictive-search')?.classList.add('active');
            this.initialSearchResults.style.display = 'none';
          } else {
            document.querySelector('#predictive-search')?.classList.remove('active');
          }
        });

        // Hide search modal on click outside
        document.addEventListener('click', (e) => {

          if(!e.target.matches('.nav-search-overlay, .nav-search-overlay *, .js-searchToggle, .js-searchToggle *, #predictive-search, #predictive-search *, #initial-search, #initial-search *')){
            if(this.predictiveSearchResults.style.display !== 'none'){
              this.close();
            };
            if(this.initialSearchResults.style.display !== 'none'){
              this.initialSearchResults.style.display = 'none';
            }
          }
        });
    }

    onInitialClick() {
      if((!this.predictiveSearchResults.style.display || this.predictiveSearchResults.style.display == 'none') && !this.input.value.length){
        this.initialSearchResults.style.display = 'grid';
      }
    }
  
    onChange() {
      const searchTerm = this.input.value.trim();
      if (!searchTerm.length) {
        this.close();
        return;
      }
  
      this.getSearchResults(searchTerm);
    }
  
    getSearchResults(searchTerm) {
      document.querySelector('#predictive-search') ? document.querySelector('#predictive-search').innerHTML = '' : null;
      this.initialSearchResults.style.display = 'none';
      fetch(`/search/suggest.json?q=${searchTerm}&resources[type]=product,article&resources[options][unavailable_products]=hide&resources[options][fields]=title,product_type,variants.title,variants.sku`)
        .then((response) => {
          if (!response.ok) {
            var error = new Error(response.status);
            this.close();
            throw error;
          }
          
          return response.json();
        })
        .then(async (suggestions) => {
            document.querySelector('#predictive-search') ? document.querySelector('#predictive-search').innerHTML = '' : null;
            suggestions.resources.results.collections = await this.searchCollections(searchTerm)
            suggestions.resources.results.pages = await this.searchPages(searchTerm);
            let resultsTopElement = document.createElement("div");
            resultsTopElement.id = "predictive-top";
            if(suggestions.resources.results.collections.length > 0 ) {
                let collectionTabElement = document.createElement("div");
                collectionTabElement.id = "search-collection-tab";
                collectionTabElement.innerHTML = `<div class="collectionsTab"><div class="collectionsHeading">Category</div><ul class="collectionsItems"></ul></div>`;
                let displayedCollections = suggestions.resources.results.collections.slice(0, 5);
                for(let collection of displayedCollections){
                    let collectionUrl = collection[1].url;
                    let collectionTitle = collection[0];
                    let collectionItemElement = document.createElement("li");
                    collectionItemElement.innerHTML = `<a target="_self" href="/collections/${collectionUrl}">${collectionTitle}</a>`;
                    collectionTabElement.querySelector('.collectionsItems').appendChild(collectionItemElement);
                }
                resultsTopElement.appendChild(collectionTabElement);
            }
           
            
            if(suggestions.resources.results.pages.length > 0 ) {
                let pagesTabElement = document.createElement("div");
                pagesTabElement.id = "search-pages-tab";
                pagesTabElement.innerHTML = `<div class="pagesTab"><div class="pagesHeading">Pages</div><ul class="pagesItems"></ul></div>`;
                let displayedPages = suggestions.resources.results.pages;
                for(let page of displayedPages){
                    let pageUrl = page.url;
                    let pageTitle = page.title;
                    let pageItemElement = document.createElement("li");
                    pageItemElement.innerHTML = `<a target="_self" href="/pages/${pageUrl}">${pageTitle}</a>`;
                    pagesTabElement.querySelector('.pagesItems').appendChild(pageItemElement);
                }
                resultsTopElement.appendChild(pagesTabElement);
            }

            if(suggestions.resources.results.articles.length > 0 ) {
                let articlesTabElement = document.createElement("div");
                articlesTabElement.id = "search-articles-tab";
                articlesTabElement.innerHTML = `<div class="articlesTab"><div class="articlesHeading">Articles</div><ul class="articlesItems"></ul></div>`;
                let displayedArticles = suggestions.resources.results.articles;
                for(let article of displayedArticles){
                    let articleUrl = article.url;
                    let articleTitle = article.title;
                    let articleItemElement = document.createElement("li");
                    articleItemElement.innerHTML = `<a target="_self" href="${articleUrl}">${articleTitle}</a>`;
                    articlesTabElement.appendChild(articleItemElement);
                }
                resultsTopElement.appendChild(articlesTabElement);
            }
            if (!document.querySelector('#predictive-search #predictive-top')) this.predictiveSearchResults.appendChild(resultsTopElement);


            let displayedProducts = [];
            let resultsBottomElement = document.createElement("div");
            resultsBottomElement.id = "predictive-bottom";
            if(suggestions.resources.results.products.length > 0 ) {
                resultsBottomElement.innerHTML = `<span class="productHeader">PRODUCTS</span><div class="productResults"></div>`;
                displayedProducts = suggestions.resources.results.products.slice(0, 4);
            }
            for(let product of displayedProducts){
                let productImage = product.featured_image.url;
                let productTitle = product.title;
                let productPrice = product.price;
                let productUrl  = product.url;
                let productCard = document.createElement("div");
                productCard.class = "searchItem";
                productCard.innerHTML = `<a class="searchItemUrl" title="${productTitle}" target="_self" href="${productUrl}"><div class="searchItemProductTop"><div class="searchImgWrap border-radius"><img class="searchImg border-radius" src="${productImage}" alt="${productTitle}" width="480" height="480"></div></div><div class="searchItemProductBottom"><div class="searchProductTitle">${productTitle}</div><div class="searchProductPrice">${theme.currency}${productPrice}</div></div></a>`;
                resultsBottomElement.querySelector('.productResults').appendChild(productCard);
            }
            if (!document.querySelector('#predictive-search #predictive-bottom')) this.predictiveSearchResults.appendChild(resultsBottomElement);

          this.open();
        })
        .catch((error) => {
          this.close();
          throw error;
        });
    }
  
    open() {
      this.predictiveSearchResults.style.display = 'block';
    }
  
    close() {
      this.predictiveSearchResults.style.display = 'none';
      this.predictiveSearchResults.innerHTML = '';
      this.initialSearchResults.style.display = 'none';
    }
  
    debounce(fn, wait) {
      let t;
      return (...args) => {
        clearTimeout(t);
        t = setTimeout(() => fn.apply(this, args), wait);
      };
    }

    async searchCollections (searchTerm) {
      const data = await fetch(`https://plank-hardware-api.herokuapp.com/collections?term=${searchTerm}`)
      const collections = await data.json();
      return collections
    }

    async searchPages (searchTerm) {
      const data = await fetch(`https://plank-hardware-api.herokuapp.com/pages?term=${searchTerm}`)
      const pages = await data.json();
      return pages
    }
  }
  
  customElements.define('predictive-search', PredictiveSearch);
  